<template>
    <div id="app">
        <div v-if="btnFlag" class="back_top hidden-xs-only" @click="backTop">
            <span>&#xe651;</span>
        </div>
        <router-view />
    </div>
</template>

<script>
export default {
    name: "App",
    mounted() {
        window.addEventListener("scroll", this.scrollToTop);
    },
    destroyed() {
        window.removeEventListener("scroll", this.scrollToTop);
    },
    data() {
      return {
        btnFlag: false
      }
    },
    methods: {
        // 点击图片回到顶部方法，加计时器是为了过渡顺滑
        backTop() {
            const that = this;
            let timer = setInterval(() => {
                let ispeed = Math.floor(-that.scrollTop / 5);
                document.documentElement.scrollTop = document.body.scrollTop =
                    that.scrollTop + ispeed;
                if (that.scrollTop === 0) {
                    clearInterval(timer);
                }
            }, 16);
        },

        // 为了计算距离顶部的高度，当高度大于60显示回顶部图标，小于60则隐藏
        scrollToTop() {
            const that = this;
            let scrollTop =
                window.pageYOffset ||
                document.documentElement.scrollTop ||
                document.body.scrollTop;
            that.scrollTop = scrollTop;
            if (that.scrollTop > 0) {
                that.btnFlag = true;
            } else {
                that.btnFlag = false;
            }
        },
    },
};
document.addEventListener("DOMContentLoaded", () => {
    const html = document.querySelector("html");
    const fontsize = window.innerWidth / 10;
    html.style.fontSize = fontsize + "px";
});
</script>

<style lang="scss" scoped>
#app {
    overflow: hidden;
    width: 100%;
    .back_top {
        position: fixed;
        z-index: 100000;
        top: 500px;
        right: 100px;
        width: 46px;
        height: 46px;
        border-radius: 50%;
        line-height: 50px;
        text-align: center;
        border: 1px solid #ccc;
        color: #ccc;
        cursor: pointer;
        span {
            font-family: "iconfont";
            font-size: 22px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/App.vue